import { render } from "./GetLoanView.vue?vue&type=template&id=41274f97&ts=true"
import script from "./GetLoanView.vue?vue&type=script&lang=ts"
export * from "./GetLoanView.vue?vue&type=script&lang=ts"

import "./GetLoanView.vue?vue&type=style&index=0&id=41274f97&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__